import React, { useState, useEffect } from 'react';
import Card from './components/Card';
import "7.css/dist/7.css";
import './App.css';

function App() {
  const [promptText, setPromptText] = useState('');
  const [copied, setCopied] = useState(false);

  const [portfolioCards, setPortfolioCards] = useState(null);
  const [situationCard, setSituationCard] = useState(null);
  const [memoryCard, setMemoryCard] = useState(null);
  const [questionCard, setQuestionCard] = useState(null);
  const [situationCards, setSituationCards] = useState([]);
  const [memoryCards, setMemoryCards] = useState([]);
  const [questionCards, setQuestionCards] = useState([]);

  useEffect(() => {
    const cardsUrl = `${process.env.PUBLIC_URL || ''}/portfolio.json`;

    fetch(cardsUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to load cards: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setPortfolioCards(data);
      })
      .catch((error) => console.error('Error loading cards:', error));
  }, []);

  useEffect(() => {
    const cardsUrl = `${process.env.PUBLIC_URL || ''}/cards.json`;

    fetch(cardsUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to load cards: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        const situations = data.filter((item) => item.type === 'situation');
        const memories = data.filter((item) => item.type === 'memory');
        const questions = data.filter((item) => item.type === 'question');
        setSituationCards(situations);
        setMemoryCards(memories);
        setQuestionCards(questions);
        drawCards(situations, memories, questions);
      })
      .catch((error) => console.error('Error loading cards:', error));
  }, []);

  const drawRandom = (list) => {
    if (!list || list.length === 0) return null;
    return list[Math.floor(Math.random() * list.length)];
  };

  const drawCards = (situations, memories, questions) => {
    const situation = drawRandom(situations);
    const memory = drawRandom(memories);
    const question = drawRandom(questions);
    setSituationCard(situation);
    setMemoryCard(memory);
    setQuestionCard(question);
    return { situation, memory, question };
  };

  const submitCardReading = (situation, memory, question) => {
    if (!situation || !memory || !question) return;

    const prompt = "give me a reading of the following three cards, just like reading tarot. the cards are formatted in json.\n\n";
    const cardsJson = JSON.stringify([situation, memory, question]);
    const fullInput = `${prompt} ${cardsJson}`;

    setPromptText(fullInput);
    setCopied(false);
  };

  const copyToClipboard = async () => {
    if (!promptText) return;

    try {
      await navigator.clipboard.writeText(promptText);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Copy failed:', err);
    }
  };

  return (
    <div className="App">
      <h1>Data Trash Snack Bar</h1>
      <div className="cards-row">
        {portfolioCards && portfolioCards.map((card) => (
          <Card key={card.name} card={card} />
        ))}
      </div>
      <button id="drawCardButton" onClick={() => {
        const { situation, memory, question } = drawCards(situationCards, memoryCards, questionCards);
        submitCardReading(situation, memory, question);
      }}>
        Draw Cards
      </button>
      <div className="cards-row">
        {situationCard && <Card card={situationCard} />}
        {memoryCard && <Card card={memoryCard} />}
        {questionCard && <Card card={questionCard} />}
      </div>
      {promptText && (
        <div className="prompt-box">
          <h2>Prompt</h2>
          <textarea
            readOnly
            value={promptText}
            rows={8}
            style={{ width: '100%', minHeight: '180px' }}
          />
          <button type="button" onClick={copyToClipboard}>
            {copied ? 'Copied!' : 'Copy to Clipboard'}
          </button>
        </div>
      )}
    </div>
  );
}

export default App;